module.exports = __webpack_public_path__ + "img/dis03.f78919fc.svg";